<ng-container *ngIf="projectSamplingActive">
  <br>
  <div class="container header">
    <h3 class="header__title">Measure Sampling</h3>
    <form-factory class="input-switch input-switch--inline" [formGroup]="measureSamplingSwitchGroup" [model]="measureSamplingActiveSwitch" (onChange)="onMeasureSamplingSwitchChange($event)"></form-factory>
  </div>
  <p class="w-50">
    Allocates a share of the project target to a specific measure. A value of 20% represents 20% of the volume
    already allocated by Project Sampling.
  </p>
  <br>
  <ng-container *ngIf="measureSamplingEnabled">
    <ng-container *ngIf="measureFormOverread?.length > 0 else noMeasures">
      <div class="container flex-gap">
        <div class="grid">
          <p class="grid__header text-align-center">Overread I</p>
          <span class="text-align-left align-self container">Measure</span>
          <div class="container justify-center">
            <p>Compliant</p>
            <div class="icon">
              <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Compliant = All numerators are compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
            </div>
          </div>
          <div class="container justify-center">
            <p>Partial Compliant</p>
            <div class="icon">
              <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Partial Compliant = At least one numerator is medical record compliant at the chase/measure level,  however other numerators are non-compliant for the same chase/measure.'" [tooltipPosition]="'top'"></app-icon>
            </div>
          </div>
          <div class="container justify-center">
            <p>Non-Compliant</p>
            <div class="icon">
              <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Non-Compliant = At least one numerator is non-compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
            </div>
          </div>
          <div class="container justify-center">
            <p>Exclusion</p>
            <div class="icon">
              <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Exclusion = Chase/Measure contains an exclusion for the measure in the appropriate timeframe.'" [tooltipPosition]="'top'"></app-icon>
            </div>
          </div>
          <ng-container *ngFor="let measureGroup of measureFormOverread; let i = index; trackBy: trackByIndex">
            <ng-container
              *ngFor="let formGroup of getControls(measureGroup.formGroup); let j = index; trackBy: trackByIndex">
              <div class="container justify-center">
                <form-factory (onChange)="onInputChange($event)" class="input" [formGroup]="measureGroup.formGroup" [model]="measureGroup.models[j]"></form-factory>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="divisor"></div>
        <div class="grid">
          <p class="grid__header text-align-center">Overread II</p>
          <div class="container justify-center">
            <p>Compliant</p>
            <div class="icon">
              <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Compliant = All numerators are compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
            </div>
          </div>
          <div class="container justify-center">
            <p>Partial Compliant</p>
            <div class="icon">
              <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Partial Compliant = At least one numerator is medical record compliant at the chase/measure level,  however other numerators are non-compliant for the same chase/measure.'" [tooltipPosition]="'top'"></app-icon>
            </div>
          </div>
          <div class="container justify-center">
            <p>Non-Compliant</p>
            <div class="icon">
              <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Non-Compliant = At least one numerator is non-compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
            </div>
          </div>
          <div class="container justify-center">
            <p>Exclusion</p>
            <div class="icon">
              <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Exclusion = Chase/Measure contains an exclusion for the measure in the appropriate timeframe.'" [tooltipPosition]="'top'"></app-icon>
            </div>
          </div>
          <span></span>
          <ng-container *ngFor="let measureGroup of measureFormOverread2; let i = index; trackBy: trackByIndex">
            <ng-container
              *ngFor="let formGroup of getControls(measureGroup.formGroup); let j = index; trackBy: trackByIndex">
              <div class="container justify-center">
                <form-factory class="input" [formGroup]="measureGroup.formGroup" [model]="measureGroup.models[j]"></form-factory>
              </div>
            </ng-container>
            <div class="container flex-gap ">
              <div class="action-button">
                <app-icon (click)="revertValues(i)" iconName="fas fa-sync"></app-icon>
              </div>
              <div class="action-button">
                <app-icon (click)="confirmDeleteRow(i)" iconName="fa-regular fa-trash"></app-icon>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
    <ng-template #noMeasures>
      <p>No measure information.</p>
    </ng-template>
    <div class="container flex-gap add-measure-row">
      <div class="container flex-gap add-measure" (click)="addMeasure()">
        <app-icon iconName="plus-circle" iconStyle="far"></app-icon>
        <span>Add Measures</span>
      </div>
      <div class="helper-text">
        <p>A blank cell (--) puts that measure into the random-fill pool for that bucket and stage.</p>
        <p>A measure set to 0% is deliberately excluded from sampling.</p>
      </div>
    </div>
  </ng-container>
</ng-container>
<app-confirmation-modal
  [(visible)]="isConfirmDeleteVisible"
  header="WARNING"
  acceptText="DELETE"
  rejectText="CANCEL"
  (onYes)="deleteRow()">
  Are you sure you want to delete this measure sampling?
</app-confirmation-modal>
